import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    recentlyDeleted: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Name of the "Trash" folder containing recently deleted assets */
            recentlyDeleted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Trash.recentlyDeleted?c=3fwnxu20vdvba", defaultMessage: "Recently Deleted" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
